export enum BankIdSessionStatus {
	Created = 0,
	GeneratedLink = 1,
	Pending = 2,
	Finished = 3,
	Failed = 4,
	Cancelled = 5,
	TimeOut = 6,
	Invalid = 7,
}
